var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFpom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26412_23425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0007 27.9546C56.0007 38.8651 49.5831 48.8957 39.6489 53.471C25.5828 59.8941 8.96715 53.647 2.54948 39.657C0.87913 35.9615 0 32.0901 0 28.0426C0 17.1322 6.41767 7.10157 16.3519 2.52621C23.1212 -0.553355 30.7696 -0.817326 37.7148 1.73432C44.7478 4.37394 50.2864 9.56522 53.3633 16.3403C55.2095 20.0358 56.0007 23.9952 56.0007 27.9546Z",
    fill: "#F4CD00"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26412_23425)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_26412_23425)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 38H22.884C23.6559 36.812 24.0454 35.416 24 34V30H31C31.2652 30 31.5196 29.8946 31.7071 29.7071C31.8946 29.5196 32 29.2652 32 29C32 28.7348 31.8946 28.4804 31.7071 28.2929C31.5196 28.1054 31.2652 28 31 28H24V24C24 22.4087 24.6321 20.8826 25.7574 19.7574C26.8826 18.6321 28.4087 18 30 18C31.5913 18 33.1174 18.6321 34.2426 19.7574C35.3679 20.8826 36 22.4087 36 24C36 24.2652 36.1054 24.5196 36.2929 24.7071C36.4804 24.8946 36.7348 25 37 25C37.2652 25 37.5196 24.8946 37.7071 24.7071C37.8946 24.5196 38 24.2652 38 24C38 21.8783 37.1571 19.8434 35.6569 18.3431C34.1566 16.8429 32.1217 16 30 16C27.8783 16 25.8434 16.8429 24.3431 18.3431C22.8429 19.8434 22 21.8783 22 24V28H20C19.7348 28 19.4804 28.1054 19.2929 28.2929C19.1054 28.4804 19 28.7348 19 29C19 29.2652 19.1054 29.5196 19.2929 29.7071C19.4804 29.8946 19.7348 30 20 30H22V34C22 35.2 21.708 38 19 38C18.7348 38 18.4804 38.1054 18.2929 38.2929C18.1054 38.4804 18 38.7348 18 39C18 39.2652 18.1054 39.5196 18.2929 39.7071C18.4804 39.8946 18.7348 40 19 40H37C37.2652 40 37.5196 39.8946 37.7071 39.7071C37.8946 39.5196 38 39.2652 38 39C38 38.7348 37.8946 38.4804 37.7071 38.2929C37.5196 38.1054 37.2652 38 37 38Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26412_23425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26412_23425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_26412_23425"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpom);
export default __webpack_public_path__ + "static/media/fpom.ccf4ecb4d5959620a4a88df097f2f41c.svg";
export { ForwardRef as ReactComponent };